const { company } = window.env;

export const isGoal = () => {
  return company.id === 'k-goal';
};
export const isGood = () => {
  return company.id === 'k-good';
};

export const hideFee = (studentId, assignData) => {
  if (!isGoal()) {
    return false;
  }

  return true;
};
